__turbopack_context__.v({
  "CmsCtaAssetBanner": "d3Jvla_CmsCtaAssetBanner",
  "contentWrapper": "d3Jvla_contentWrapper",
  "custom": "d3Jvla_custom",
  "custom-2": "d3Jvla_custom-2",
  "double": "d3Jvla_double",
  "imageWrapper": "d3Jvla_imageWrapper",
  "type-sidelines": "d3Jvla_type-sidelines",
  "type-sidelines-dotted": "d3Jvla_type-sidelines-dotted",
});
